import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";

const initialState = {
  roomsList: [],
  roomDataGridOptions: {
    loading: false,
    rows: [],
    totalRows: 0,
    rowsPerPageOptions: rowsPerPageJsonData,
    pageSize: 50,
    page: 1,
  },
  roomSearchFilters: {
    searchText: "",
    roomStatus: 0,
    floor_no: 0,
    room_category_type: 0,
  },
  roomCategorySelect: [],
  roomDetail: null,
  roomsBookingRestrictionList: [],
  roomsBookingRestrictionDetail: null,
  roomsCalenderList: [],
  cancellationPolicyList: [],
  refreshPolicy: false,
  cleaningChecklist: [],
  refreshCleaning: false,
  nonRoomAreaList: [],
  refreshNonRoomArea: false,
};
const roomSlice = createSlice({
  name: "room",
  initialState: initialState,
  reducers: {
    roomListSuccess: (state, action) => {
      state.roomsList = action.payload;
    },
    roomListFailed: (state, action) => {
      state.roomsList = [];
    },
    roomDataGridOptionsSuccess: (state, action) => {
      state.roomDataGridOptions = {
        ...state.roomDataGridOptions,
        [action.payload.key]: action.payload.value,
      };
    },
    roomSearchFiltersSuccess: (state, action) => {
      state.roomSearchFilters = {
        ...state.roomSearchFilters,
        [action.payload.key]: action.payload.value,
      };
    },
    roomCategorySelectSuccess: (state, action) => {
      state.roomCategorySelect = action.payload;
    },
    roomCalenderListSuccess: (state, action) => {
      state.roomsCalenderList = action.payload;
    },
    roomCalenderListFailed: (state, action) => {
      state.roomsCalenderList = [];
    },
    roomsBookingRestrictionListSuccess: (state, action) => {
      state.roomsBookingRestrictionList = action.payload;
    },
    roomsBookingRestrictionListFailed: (state, action) => {
      state.roomsBookingRestrictionList = [];
    },
    cancellationPolicyListSuccess: (state, action) => {
      state.cancellationPolicyList = action.payload;
    },
    cancellationPolicyListFailed: (state, action) => {
      state.cancellationPolicyList = [];
    },
    cleaningChecklistSuccess: (state, action) => {
      state.cleaningChecklist = action.payload;
    },
    cleaningChecklistFailed: (state, action) => {
      state.cleaningChecklist = [];
    },
    refreshCleaningSuccess: (state, action) => {
      state.refreshCleaning = true;
    },
    refreshCleaningFailed: (state, action) => {
      state.refreshCleaning = false;
    },
    nonRoomAreaListSuccess: (state, action) => {
      state.nonRoomAreaList = action.payload;
    },
    nonRoomAreaListFailed: (state, action) => {
      state.nonRoomAreaList = [];
    },
    refreshNonRoomAreaSuccess: (state, action) => {
      state.refreshNonRoomArea = true;
    },
    refreshNonRoomAreaFailed: (state, action) => {
      state.refreshNonRoomArea = false;
    },
    roomDetailSuccess: (state, action) => {
      state.roomDetail = action.payload;
    },
    roomDetailFailed: (state, action) => {
      state.roomDetail = null;
    },
    refreshPolicySuccess: (state, action) => {
      state.refreshPolicy = true;
    },
    refreshPolicyFailed: (state, action) => {
      state.refreshPolicy = false;
    },
    roomsBookingRestrictionDetailSuccess: (state, action) => {
      state.roomsBookingRestrictionDetail = action.payload;
    },
    roomsBookingRestrictionDetailFailed: (state, action) => {
      state.roomsBookingRestrictionDetail = null;
    },
  },
});

export const {
  roomListSuccess,
  roomListFailed,
  roomDataGridOptionsSuccess,
  roomSearchFiltersSuccess,
  roomCalenderListSuccess,
  roomCalenderListFailed,
  roomDetailSuccess,
  roomDetailFailed,
  roomsBookingRestrictionDetailSuccess,
  roomsBookingRestrictionDetailFailed,
  roomsBookingRestrictionListSuccess,
  roomsBookingRestrictionListFailed,
  cancellationPolicyListSuccess,
  cancellationPolicyListFailed,
  refreshPolicy,
  refreshPolicySuccess,
  refreshPolicyFailed,
  cleaningChecklistSuccess,
  cleaningChecklistFailed,
  refreshCleaningSuccess,
  refreshCleaningFailed,
  nonRoomAreaListSuccess,
  nonRoomAreaListFailed,
  refreshNonRoomAreaSuccess,
  refreshNonRoomAreaFailed,
  roomCategorySelectSuccess,
} = roomSlice.actions;
export default roomSlice.reducer;
